import React from "react";

const Navbar = () => {
  return (
    <nav className="bg-white p-4 lg:px-40 shadow-md  sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-lg font-bold">PAWAN KAAZ</div>
        <div className="flex space-x-4">
         
        
        
        </div>
        <div className="flex space-x-4">
         
          <button className="bg-black text-white px-4 py-2 rounded">
            LOGIN
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
